// src/features/settings/SettingsWorkspacePage.tsx
import { LoadingBoundary, PageContainer } from '../../app/components/foundation';
import { SettingsHeader, SettingsLiveOverview } from './components';
import { useSettings } from './hooks/useSettings';
import './styles/settings.css';

/**
 * Settings Workspace Foundation (/settings/:id). Same shell pattern
 * as PermissionWorkspacePage/CustomerWorkspacePage: PageContainer +
 * feature-owned header, card grid below, RTL/Persian throughout,
 * existing tokens/primitives only.
 *
 * Reads `id` from the route params and resolves everything through
 * useSettingsWorkspaceMock(id) — the group record plus its
 * fields/access/modules/timeline, all still mock data from
 * data/settings.mock.ts. No API calls; useSettingsWorkspaceMock is
 * the seam a later phase swaps for a real settings-detail hook
 * without touching this file or the cards below it (same shape).
 */
export function SettingsWorkspacePage() {
  const { settings, loading, error } = useSettings();

  return (
    <PageContainer className="flex flex-col gap-6">
      <SettingsHeader />
      <LoadingBoundary loading={loading} error={error}>
        {settings ? <SettingsLiveOverview settings={settings} /> : null}
      </LoadingBoundary>
    </PageContainer>
  );
}
